const DURATION_READ_TIMEOUT_MS = 5000;

/**
 * Reads an audio file's duration via an <audio> element's metadata.
 *
 * Returns 0 (not an error) on timeout, decode error, or a non-finite duration — some
 * containers (certain m4a/webm) never fire `loadedmetadata` or report Infinity/NaN.
 * 0 is safe: the server only uses msDuration to decide chunk routing and falls back to
 * the file-size gate when it's missing.
 */
export const readAudioDurationMs = (file: File): Promise<number> => {
    return new Promise((resolve) => {
        const url = URL.createObjectURL(file);
        const audio = new Audio(url);
        let settled = false;

        const finish = (ms: number) => {
            if (settled) {
                return;
            }
            settled = true;
            clearTimeout(timeout);
            URL.revokeObjectURL(url);
            resolve(ms);
        };

        const timeout = setTimeout(() => finish(0), DURATION_READ_TIMEOUT_MS);

        audio.addEventListener('loadedmetadata', () => {
            const seconds = audio.duration;
            finish(Number.isFinite(seconds) && seconds > 0 ? Math.round(seconds * 1000) : 0);
        });
        audio.addEventListener('error', () => finish(0));
    });
};
